import { useCreditStore } from "../stores/creditStore";
import { CreditInformationResponse, UserConfig } from "../api/types";
import { StoreCreditType } from "../config/creditRegistry";

interface UseCreditDataReturn {
  creditInfo: Record<StoreCreditType, CreditInformationResponse | null>;
  isLoading: boolean;
  error: string | null;
  userConfig: UserConfig["config"] | null;
  refreshPositions: (creditTypes: StoreCreditType[]) => Promise<void>;
  isRefreshingPositions: boolean;
}

export function useCreditData(): UseCreditDataReturn {
  const {
    creditInfo,
    isLoading,
    error,
    _refreshPositions,
    isRefreshingPositions,
    userConfig,
  } = useCreditStore();

  return {
    creditInfo,
    isLoading,
    error,
    userConfig,
    refreshPositions: _refreshPositions,
    isRefreshingPositions,
  };
}
